const validArrayFormat = (array, callback) => {
  return array ? callback(array) : []
}

export const formatOffice = (officeArray) =>
  validArrayFormat(officeArray, (array) =>
    array.map((element) => ({
      id: element?.sSucursal,
      value: element?.sSucursal,
      label: element?.sDescripcion,
      ...element,
    })),
  )
export const formatStringNumber = (stringNumber) => {
  if (stringNumber) {
    const stringAsNumber = +stringNumber
    return Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
    }).format(stringAsNumber)
  }
  return ''
}
export const formatCostCenter = (costCenterArray) =>
  validArrayFormat(costCenterArray, (array) =>
    array.map((element) => ({
      id: element?.sCentroCosto,
      value: element?.sCentroCosto,
      label: element?.sDescripcion,
      ...element,
    })),
  )
export const formatGroup = (groupArray) =>
  validArrayFormat(groupArray, (array) =>
    array.map((element) => ({
      id: element?.idGrupo,
      value: element?.idGrupo,
      label: element?.sDescripcion,
      ...element,
    })),
  )

export const numberFormat = (value, type) => {
  if (!value) return value
  let number = value
  if (typeof value === 'string') {
    if (value.includes(',')) {
      number = value.substring(0, value.indexOf(','))
    }

    const formatValue = number?.match(/\d/g)?.join('') || 0
    number = Number(formatValue) || 0

    if (value.includes('-')) {
      number = -number
    }
  }
  if (type === 'currency') {
    return currencyFormat(number)
  }
  return number
}

export const currencyFormat = (number) => {
  const style = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }
  const formatter = new Intl.NumberFormat(['es'], style)
  let formatNumber = formatter.format(number)
  if (formatNumber.length === 4) {
    formatNumber = `${formatNumber[0]}.${formatNumber.substring(
      1,
      formatNumber.length,
    )}`
  }
  return `$${formatNumber}`
}

export const formatBlockData = (data) =>
  data.map((el) => ({
    sEmpresa: el.sEmpresa,
    sEmpleado: el.sEmpleado,
    bReposicion: false,
  }))
export const formatResetCards = (cards) =>
  cards.map((el) => ({
    sCuentaNN: el.sEmpleado,
  }))

const digitValidator = (rut) => {
  let multi = 0
  let newRut = rut
  let S = 1
  // El paso del for y el módulo deben operar sobre `newRut` (no `rut`, que es
  // constante) o el bucle nunca termina. El multiplicador se incrementa DESPUÉS
  // de usarse para coincidir con Fn.dv en validators.js (misma fuente de verdad).
  for (; newRut; newRut = Math.floor(newRut / 10)) {
    S = (S + (newRut % 10) * (9 - (multi++ % 6))) % 11
  }
  return S ? S - 1 : 'K'
}

const unformat = (rut) => rut.replace(/[^0-9kK]/g, '')
export const RutValidator = (rut) => {
  const rutUnformat = unformat(rut)
  if (rut.length > 4) {
    const rutNumber = parseInt(rutUnformat.slice(0, -1), 10)
    const digv = rutUnformat.slice(-1)

    if (digv !== 'K' && digv !== 'k') {
      return digitValidator(rutNumber) === parseInt(digv, 10)
    }
    return digitValidator(rutNumber) === digv.toLocaleUpperCase()
  }
  return false
}

export const formatRut = (rut = '') => {
  const current = rut.replace(/^0+/, '')

  if (current !== '' && current.length > 1) {
    const unformatRut = unformat(current)
    const cleanRut = unformatRut.substring(0, unformatRut.length - 1)
    let rutNumberFormat = ''

    let i = 0
    let j = 1

    for (i = cleanRut.length - 1; i >= 0; i -= 1) {
      rutNumberFormat = cleanRut.charAt(i) + rutNumberFormat
      if (j % 3 === 0 && j <= cleanRut.length - 1) {
        rutNumberFormat = `.${rutNumberFormat}`
      }
      j += 1
    }

    const dv = unformatRut.substring(unformatRut.length - 1)
    rutNumberFormat = `${rutNumberFormat}-${dv}`
    return { value: unformatRut, formatValue: rutNumberFormat }
  }
  return { value: current, formatValue: current }
}
